export default __webpack_public_path__ + "static/001-248a232b9539a643d8d833e71765d688.jpg";